import styled, { css } from 'styled-components';
import { BoxBase } from '@storeblocks/box/lib/styled';
export const SurfaceBase = styled(BoxBase).attrs({
    className: 'surface',
}) `
  background: var(--color-surface);
  display: block;

  ${({ variant }) => {
    if (variant === 'alt') {
        return css `
        background: var(--color-surface-variant);
      `;
    }
    if (variant === 'border') {
        return css `
        background: var(--color-background);
        border: 3px solid var(--color-surface-border);
      `;
    }
    if (variant === 'border-alt') {
        return css `
        background: var(--color-background);
        border: 3px solid var(--color-surface-variant-border);
      `;
    }
    return '';
}}
`;
